import { useState } from 'react';

import type { FloorPlanTierId } from './floorPlanOffer';
import { FLOOR_PLAN_TIER_CONTENT } from './floorPlanTierContent';

interface FloorPlanTierImageProps {
  tierId: FloorPlanTierId;
  /** The service's catalog image (DV-3808); null when it has none. */
  onlineImage: string | null;
  className?: string;
  width?: number;
  height?: number;
}

/**
 * A floor plan tier's picture on its card and on the cart's floor plan line:
 * the service's catalog `onlineImage`, as every other service card shows
 * (DV-3808), so changing it is a data change, not a release. The bundled
 * example stands in when the service has none, and when its image fails to
 * load, so a deleted or blocked URL never shows a broken image where the
 * bundled one used to be.
 */
export function FloorPlanTierImage({
  tierId,
  onlineImage,
  ...imgProps
}: FloorPlanTierImageProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const src =
    onlineImage && onlineImage !== failedSrc
      ? onlineImage
      : FLOOR_PLAN_TIER_CONTENT[tierId].exampleImage;

  return (
    <img
      {...imgProps}
      src={src}
      alt=""
      onError={() => {
        if (src === onlineImage) setFailedSrc(onlineImage);
      }}
    />
  );
}
